<ng-container screenAnalytics="location-edit-kml">
    <div class="modal-header">
        <h3 class="modal-title">Geometry Upload Feature Setup</h3>
        <enhanced-help-switch></enhanced-help-switch>
        <knowledge-base-link></knowledge-base-link>
        <button
            type="button"
            (click)="close()"
            aria-label="Close"
            class="close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <enhanced-help class="no-min-height" componentName="screen">
        </enhanced-help>
        <div class="horizontal-container center-children">
            <div class="checkbox fill">
                <label>
                    <input
                        type="checkbox"
                        [checked]="allFeaturesIncluded"
                        (change)="toggleAllFeatures()"
                    />
                    <span class="cr">
                        <i class="cr-icon glyphicon glyphicon-ok"></i>
                    </span>
                    Select all
                </label>
            </div>
            <span class="text-muted">
                {{ includedFeatures.size }} of {{ totalFeatureCount }} features
                selected
            </span>
        </div>
        <div *ngIf="areas != null">
            <h5 class="section-heading">
                <span>Areas</span>
                <div></div>
            </h5>
            <div class="horizontal-container fill top-buffer bottom-buffer">
                <div class="fcol-h"></div>
                <div class="fcol-5">
                    <label class="display-label">Name</label>
                </div>
                <div class="fcol-h"></div>
                <div class="fcol-4">
                    <label class="display-label">Type</label>
                </div>
                <div class="fcol-2">
                    <label class="display-label">Buffer (m)</label>
                </div>
            </div>
            <ng-container *ngFor="let feature of areas.features; let i = index">
                <div class="horizontal-container fill top-buffer">
                    <div class="fcol-h checkbox">
                        <label>
                            <input
                                type="checkbox"
                                [checked]="isIncluded(feature)"
                                (change)="toggleFeature(feature)"
                            />
                            <span class="cr">
                                <i class="cr-icon glyphicon glyphicon-ok"></i>
                            </span>
                        </label>
                    </div>
                    <div class="fcol-5">
                        <input
                            class="form-control"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="feature.name"
                            [disabled]="!isIncluded(feature)"
                            placeholder="Feature name"
                        />
                        <p *ngIf="feature.layer != null" class="help-block">
                            Layer: {{ feature.layer }}
                        </p>
                    </div>
                    <div class="fcol-h"></div>
                    <ng-select
                        class="fcol-4"
                        [items]="areaFeatureTypes"
                        bindValue="value"
                        bindLabel="name"
                        [(ngModel)]="feature.featureType"
                        [readonly]="!isIncluded(feature)"
                        appendTo="body"
                        [clearable]="false"
                        placeholder="Select an feature type"
                    >
                        <ng-template
                            ng-option-tmp
                            let-item="item"
                            let-index="index"
                        >
                            {{ item.name }}
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            {{ formatFeatureType(feature.featureType) }}
                        </ng-template>
                    </ng-select>
                    <input
                        type="number"
                        class="form-control fcol-2 left-buffer"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="feature.properties.bufferMeters"
                        [disabled]="!isIncluded(feature)"
                    />
                </div>
            </ng-container>
        </div>
        <div *ngIf="markers != null">
            <h5 class="section-heading">
                <span>Markers</span>
                <div></div>
            </h5>
            <div class="horizontal-container fill top-buffer bottom-buffer">
                <div class="fcol-h"></div>
                <div class="fcol-6">
                    <label class="display-label">Name</label>
                </div>
                <div class="fcol-h"></div>
                <div class="fcol-5">
                    <label class="display-label">Type</label>
                </div>
            </div>
            <ng-container
                *ngFor="let feature of markers.features; let i = index"
            >
                <div class="horizontal-container fill top-buffer">
                    <div class="fcol-h checkbox">
                        <label>
                            <input
                                type="checkbox"
                                [checked]="isIncluded(feature)"
                                (change)="toggleFeature(feature)"
                            />
                            <span class="cr">
                                <i class="cr-icon glyphicon glyphicon-ok"></i>
                            </span>
                        </label>
                    </div>
                    <div class="fcol-6">
                        <input
                            class="form-control"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="feature.name"
                            [disabled]="!isIncluded(feature)"
                            placeholder="Feature name"
                        />
                        <p *ngIf="feature.layer != null" class="help-block">
                            Layer: {{ feature.layer }}
                        </p>
                    </div>
                    <div class="fcol-h"></div>
                    <ng-select
                        class="fcol-5"
                        [items]="markerFeatureTypes"
                        bindValue="value"
                        bindLabel="name"
                        [(ngModel)]="feature.featureType"
                        [readonly]="!isIncluded(feature)"
                        appendTo="body"
                        [clearable]="false"
                        placeholder="Select an feature type"
                    >
                        <ng-template
                            ng-option-tmp
                            let-item="item"
                            let-index="index"
                        >
                            {{ item.name }}
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            {{ formatFeatureType(feature.featureType) }}
                        </ng-template>
                    </ng-select>
                </div>
            </ng-container>
        </div>
        <div *ngIf="lines != null">
            <h5 class="section-heading">
                <span>Lines</span>
                <div></div>
            </h5>
            <div class="horizontal-container fill top-buffer bottom-buffer">
                <div class="fcol-h"></div>
                <div [ngClass]="hasCorridorLines ? 'fcol-5' : 'fcol-6'">
                    <label class="display-label">Name</label>
                </div>
                <div class="fcol-h"></div>
                <div [ngClass]="hasCorridorLines ? 'fcol-4' : 'fcol-5'">
                    <label class="display-label">Type</label>
                </div>
                <div *ngIf="hasCorridorLines" class="fcol-2">
                    <label class="display-label">Offset (m)</label>
                </div>
            </div>
            <ng-container *ngFor="let feature of lines.features; let i = index">
                <div class="horizontal-container fill top-buffer">
                    <div class="fcol-h checkbox">
                        <label>
                            <input
                                type="checkbox"
                                [checked]="isIncluded(feature)"
                                (change)="toggleFeature(feature)"
                            />
                            <span class="cr">
                                <i class="cr-icon glyphicon glyphicon-ok"></i>
                            </span>
                        </label>
                    </div>
                    <div [ngClass]="hasCorridorLines ? 'fcol-5' : 'fcol-6'">
                        <input
                            class="form-control"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="feature.name"
                            [disabled]="!isIncluded(feature)"
                            placeholder="Feature name"
                        />
                        <p *ngIf="feature.layer != null" class="help-block">
                            Layer: {{ feature.layer }}
                        </p>
                    </div>
                    <div class="fcol-h"></div>
                    <ng-select
                        [ngClass]="hasCorridorLines ? 'fcol-4' : 'fcol-5'"
                        [items]="lineFeatureTypes"
                        bindValue="value"
                        bindLabel="name"
                        [(ngModel)]="feature.featureType"
                        [readonly]="!isIncluded(feature)"
                        (change)="onLineTypeChange(feature)"
                        appendTo="body"
                        [clearable]="false"
                        placeholder="Select an feature type"
                    >
                        <ng-template
                            ng-option-tmp
                            let-item="item"
                            let-index="index"
                        >
                            {{ item.name }}
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            {{ formatFeatureType(feature.featureType) }}
                        </ng-template>
                    </ng-select>
                    <input
                        *ngIf="isCorridorType(feature.featureType)"
                        type="number"
                        min="1"
                        class="form-control fcol-2 left-buffer"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="feature.properties.lineOffsetMeters"
                        [disabled]="!isIncluded(feature)"
                        (ngModelChange)="onLineOffsetChange(feature)"
                    />
                </div>
            </ng-container>
        </div>
        <div *ngIf="corridors != null">
            <h5 class="section-heading">
                <span>Corridors</span>
                <div></div>
            </h5>
            <div class="horizontal-container fill top-buffer bottom-buffer">
                <div class="fcol-h"></div>
                <div class="fcol-6">
                    <label class="display-label">Name</label>
                </div>
                <div class="fcol-h"></div>
                <div class="fcol-5">
                    <label class="display-label">Type</label>
                </div>
            </div>
            <ng-container
                *ngFor="let feature of corridors.features; let i = index"
            >
                <div class="horizontal-container fill top-buffer">
                    <div class="fcol-h checkbox">
                        <label>
                            <input
                                type="checkbox"
                                [checked]="isIncluded(feature)"
                                (change)="toggleFeature(feature)"
                            />
                            <span class="cr">
                                <i class="cr-icon glyphicon glyphicon-ok"></i>
                            </span>
                        </label>
                    </div>
                    <div class="fcol-6">
                        <input
                            class="form-control"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="feature.name"
                            [disabled]="!isIncluded(feature)"
                            placeholder="Feature name"
                        />
                        <p *ngIf="feature.layer != null" class="help-block">
                            Layer: {{ feature.layer }}
                        </p>
                    </div>
                    <div class="fcol-h"></div>
                    <ng-select
                        class="fcol-5"
                        [items]="corridorFeatureTypes"
                        bindValue="value"
                        bindLabel="name"
                        [(ngModel)]="feature.featureType"
                        [readonly]="!isIncluded(feature)"
                        appendTo="body"
                        [clearable]="false"
                        placeholder="Select an feature type"
                    >
                        <ng-template
                            ng-option-tmp
                            let-item="item"
                            let-index="index"
                        >
                            {{ item.name }}
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            {{ formatFeatureType(feature.featureType) }}
                        </ng-template>
                    </ng-select>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-primary"
            [disabled]="includedFeatures.size === 0"
            (click)="import()"
        >
            Done
        </button>
    </div>
</ng-container>
